module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"showMore":"Vis flere videoer","videos":"videoer"},"en":{"showMore":"Show more videos","videos":"videos"}}')
  delete Component.options._Ctor
}
